export const reducerHandler = type => (state = {}, action) => {
  if (type === action.type) {
    return action.payload;
  }
  return state;
};

const createReducer = initialState => reducerMap => (
  state = initialState,
  action,
) => {
  const reducer = reducerMap[action.type];
  return reducer ? reducer(state, action) : state;
};
export default createReducer;



// WEBPACK FOOTER //
// ./src/state/reducerHelper.js